import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Header from '~/Components/Header';
import AuthStorage from '~/Utils/AuthStorage';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { FaSpinner } from 'react-icons/fa';
import { LoadingContainer } from '~/Components/Loading/styles';
import { APIBASE } from '~/constants';
import { caracteristicas } from '~/constants';
import JSZip from 'jszip';

export default function Formatador() {
  const [carregando, setCarregando] = useState(false);
  const [centroCustoSelecionado, setCentroCustoSelecionado] = useState('');

  const verificarCentroCusto = () => {
    if (centroCustoSelecionado) {
      return false;
    }
    return true;
  };

  const obterValorCentroCusto = event => {
    if (!event || event.target.value === ' ') {
      return;
    }
    setCentroCustoSelecionado(event.target.value);
  };

  const arquivoRef = React.createRef();

  const NormalizarArquivo = async arquivo => {
    try {
      if (!arquivo) {
        arquivoRef.current.Value = '';
        toast.error('Arquivo vazio.');
        return;
      }

      if (!arquivo.name.includes('.csv') && !arquivo.name.includes('.xlsx')) {
        arquivoRef.current.Value = '';
        toast.error('Extensão de arquivo inválida.');
        return;
      }

      setCarregando(true);
      let token = AuthStorage.getToken()
        ? 'Bearer ' + AuthStorage.getToken()
        : null;

      let request = new FormData();
      request.append('Arquivo', arquivo);
      request.append('CentroCusto', centroCustoSelecionado);
      let response = await Axios.post(
        APIBASE + '/exportador/normalizar-planilha-sienge',
        request,
        {
          headers: {
            Authorization: token,
          },
          responseType: 'blob',
        }
      );

      if (response && response.status === 200) {
        const zipBlob = response.data;

        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('zip')) {
          JSZip.loadAsync(zipBlob).then(async zip => {
            const avisosFile = await zip.file('Avisos.json');

            if (avisosFile) {
              const avisosContent = await avisosFile.async('string');
              const avisosJson = JSON.parse(avisosContent);
              if (avisosJson.Avisos?.length) {
                toast.warn(
                  `Avisos: ${avisosJson.Avisos.length} Linha(s) com inconsistência`
                );
                console.warn(avisosJson.Avisos.join('\n'));
              }
            }

            // Lê Planilha_Normalizada.csv
            const csvFile = zip.file('Planilha_Normalizada.csv');
            if (csvFile) {
              const csvBlob = await csvFile.async('blob');
              const url = window.URL.createObjectURL(csvBlob);
              const link = document.createElement('a');
              link.href = url;
              link.download = 'Planilha_Normalizada.csv';
              link.click();
              window.URL.revokeObjectURL(url);
              link.remove();
              toast.success('Arquivo normalizado com sucesso.');
              setCentroCustoSelecionado('');
            } else {
              toast.error('Arquivo CSV não encontrado no zip.');
            }
          });
        } else {
          // Fallback: Baixa como CSV puro
          const blob = response.data;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'Planilha_Normalizada.csv';
          link.click();
          window.URL.revokeObjectURL(url);
          link.remove();
          toast.info(
            'Arquivo retornado não é um ZIP. Baixando como CSV simples.'
          );
        }
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const reader = new FileReader();
        reader.onload = () => {
          toast.error(`Erro: ${reader.result}`);
        };
        reader.readAsText(error.response.data);
      } else {
        const blob = error.data;
        const text = await blob.text();
        try {
          const json = JSON.parse(text);
          toast.error(json.Message || json.message || text);
        } catch {
          toast.error(text);
        }
      }
    } finally {
      setCarregando(false);
    }
  };

  return (
    <>
      {AuthStorage.temCaracteristica(caracteristicas.ConverterFolhaSienge) && (
        <>
          <Header title="Normalizar planilha"></Header>
          <div className="alert alert-info">
            <h4 className="alert-heading">Instruções de uso</h4>
            <ol>
              <li>
                A folha de pagamento deve ser extraída do sistema Questor.
              </li>
              <li>
                Os arquivos devem estar nos formatos .xlsx ou .csv para
                viabilizar a conversão.
              </li>
              <li>A inclusão do centro de custo é obrigatória.</li>
            </ol>
          </div>
          {!carregando && (
            <div className="container mt-4 justify-content-center">
              <Row className="justify-content-center">
                <Col xs={12} md={6}>
                  <label>
                    Selecione o centro de custo.
                    <select
                      className="form-control"
                      onChange={event => {
                        obterValorCentroCusto(event);
                      }}
                    >
                      <option value="">Selecione...</option>
                      <option value="90009">
                        90009 (antigo 23802) - Setlife Uberaba
                      </option>
                      <option value="90015">
                        90015 (antigo 29104) - SOBRADOS ALTO PADRÃO SETSUL 2
                      </option>
                    </select>
                  </label>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col xs={12} md={6}>
                  <label htmlFor="UploadArquivo" className="mb-0">
                    <button
                      className="btn btn-primary mt-2"
                      type="button"
                      onClick={() => {
                        arquivoRef.current.click();
                      }}
                      disabled={verificarCentroCusto()}
                    >
                      Adicionar arquivo
                    </button>
                    <input
                      type="file"
                      className="d-none"
                      name="UploadArquivo"
                      id="UploadArquivo"
                      ref={arquivoRef}
                      onChange={event => {
                        NormalizarArquivo(event.target.files[0]);
                      }}
                    />
                  </label>
                </Col>
              </Row>
            </div>
          )}
          {carregando && (
            <div>
              <LoadingContainer>
                <FaSpinner className="spinner" /> Formatando arquivo...
              </LoadingContainer>
            </div>
          )}
        </>
      )}
      {!AuthStorage.temCaracteristica(caracteristicas.ConverterFolhaSienge) && (
        <div className="text-center mt-4">
          <h4> Usuário sem permissão para acessar a tela.</h4>
        </div>
      )}
    </>
  );
}
